/*
 * Client-side feature flags.
 *
 * Read once at module load. Keep the surface tiny — each flag is a plain
 * `const boolean` — so consumers import a named symbol and the minifier
 * inlines false branches. A runtime object + dynamic key would work too,
 * but it would defeat tree-shaking and we specifically want dead branches
 * to drop when a flag is off.
 *
 * Campaigns stay off unless explicitly enabled for a build.
 */

/** Helper: parse `"false" | "0" | "off"` (any case) as off; everything else is on. */
function readFlag(raw: unknown, defaultOn: boolean): boolean {
  if (raw === undefined || raw === null) return defaultOn;
  const s = String(raw).trim().toLowerCase();
  if (s === '' || s === 'false' || s === '0' || s === 'off' || s === 'no') return false;
  return true;
}

/** Campaign-mode UI: masthead entry + all /campaigns|/sets|/operations routes. */
export const FEATURE_CAMPAIGNS = readFlag(import.meta.env.VITE_FEATURE_CAMPAIGNS, false);

export function isCampaignKind(kind: string | null | undefined): boolean {
  return kind === 'campaign' || kind === 'operation_set' || kind === 'operation';
}

export function isCampaignHref(href: string | null | undefined): boolean {
  if (!href) return false;
  const base = typeof window === 'undefined' ? 'https://know.sh' : window.location.origin;
  try {
    const url = new URL(href, base);
    const local = url.origin === base || /(^|\.)know\.sh$/.test(url.hostname);
    return local && /^\/(campaigns|sets|operation-sets|operations)(\/|$)/.test(url.pathname);
  } catch {
    return false;
  }
}

export const FEATURE_TEAM = readFlag(import.meta.env.VITE_TEAM_ENABLED, false);

export const FEATURE_TEAM_DISCONNECT = readFlag(import.meta.env.VITE_TEAM_DISCONNECT_ENABLED, true);
